import * as React from 'react';
import {connect} from 'react-redux';

import {change, formValueSelector, Field} from 'redux-form';

import {SlackAuthBanner} from 'shells/form/slack/slack-auth-banner';
import {SlackMessagePreview} from 'shells/form/slack/slack-message-preview';
import {SlackMessagePreviewContent} from 'shells/form/slack/slack-message-preview-content';
import {nonNull} from 'shells/form/validation/non-null';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Body} from 'shells/typography/body';

import {GraphQLSelectSlackChannels} from '../../../../core/select/graphql-select-slack-channels';

import {FORM_NAME} from '../next-steps-constants';

const nextStepsSelector = formValueSelector(FORM_NAME);

// @ts-expect-error
function mapStateToProps(state): StateProps {
    return {
        channelId: nextStepsSelector(state, 'channelId'),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onChannelChange: (newValue?: string | null) => {
            dispatch(change(FORM_NAME, 'channelId', newValue));
        },
    };
}

type OwnProps = {
    previewMessage: React.ReactNode;
    topRowText?: string;
};

type StateProps = {
    channelId: string[];
};

type DispatchProps = {
    onChannelChange: (newValue?: string | null | undefined) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

export function NextStepsFormSlackMessageComponent(props: Props) {
    if (!NutClientConfig.integrations.slackEnabled) {
        return (
            <SlackAuthBanner text='Connect with Slack to update your team whenever a form is submitted' />
        );
    }

    return (
        <div>
            <SpacerGroup mb={8}>
                <Body>Post Slack notification to…</Body>
            </SpacerGroup>
            <SpacerGroup mb={24}>
                <Field
                    name='channelId'
                    component={GraphQLSelectSlackChannels}
                    props={{
                        selectedId: props.channelId,
                        // @ts-expect-error
                        onChange: (value) => props.onChannelChange(value.externalId),
                        onClearValue: () => props.onChannelChange(null),
                    }}
                    validate={[nonNull]}
                />
            </SpacerGroup>
            {props.channelId ? (
                <SlackMessagePreview
                    // @ts-expect-error
                    previewContent={<SlackMessagePreviewContent topRowText={props.topRowText} />}
                    previewMessage={props.previewMessage}
                />
            ) : undefined}
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const NextStepsFormSlackMessage = connector(NextStepsFormSlackMessageComponent);
